import { render, staticRenderFns } from "./PreparationBody.vue?vue&type=template&id=1a61e336&scoped=true&"
import script from "./PreparationBody.vue?vue&type=script&lang=ts&"
export * from "./PreparationBody.vue?vue&type=script&lang=ts&"
import style0 from "./PreparationBody.vue?vue&type=style&index=0&id=1a61e336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61e336",
  null
  
)

export default component.exports